import SiteLayout from '@/components/feature/SiteLayout';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntrances from './components/CategoryEntrances';
import LatestGrid from './components/LatestGrid';
import HotRanking from './components/HotRanking';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryEntrances />
      <LatestGrid />
      <HotRanking />
      <SiteIntro />
    </SiteLayout>
  );
}